var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1027 831",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:23.4582}\r\n    .str0 {stroke:black;stroke-width:23.4582}\r\n    .fil0 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil2 {fill:#FDD945}\r\n    .fil1 {fill:red}\r\n    .fil6 {fill:#FF6600}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_552370808"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1027,
    height: 831
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M514 54c36,0 67,23 75,53 6,-1 13,-2 19,-2 43,0 77,31 77,69 0,38 -34,69 -77,69 -36,0 -67,-23 -74,-53 -7,1 -13,2 -20,2 -7,0 -14,-1 -20,-2 -8,30 -39,53 -75,53 -42,0 -77,-31 -77,-69 0,-38 35,-69 77,-69 7,0 13,1 20,2 8,-30 38,-53 75,-53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str1",
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M453 483l-47 0 0 0 0 -2 0 -3 -1 -2 0 -2 0 -2 -1 -2 0 -1 -1 -2 -1 -2 -1 -2 -1 -1 0 -2 -1 -2 -2 -1 -1 -2 -1 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 -1 -1 0 -2 -1 -1 0 -2 -1 -1 0 -2 0 -1 -1 -2 0 0 -47 4 1 4 0 5 1 4 0 4 1 4 2 3 1 4 2 4 1 3 2 4 2 3 3 3 2 3 3 3 3 3 2 2 4 3 3 2 3 2 3 2 4 2 3 2 4 1 4 2 4 1 4 1 4 1 4 1 4 0 4 0 4 1 5 0 0zm-81 86l0 -47 0 0 2 0 1 0 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 -1 1 -1 1 -1 2 -1 1 -1 1 -2 1 -1 1 -2 2 -1 1 -2 0 -1 1 -2 1 -2 1 -1 1 -2 0 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 47 0 -1 4 0 4 0 4 -1 5 -1 4 -1 4 -1 4 -2 4 -1 3 -2 4 -2 4 -2 3 -2 3 -2 4 -3 3 -2 3 -3 3 -3 3 -3 2 -3 3 -3 2 -4 2 -3 2 -4 2 -4 1 -3 2 -4 1 -4 1 -4 1 -5 0 -4 1 -4 0 0 0zm-81 -86l47 0 0 0 0 2 0 2 1 2 0 2 0 2 1 2 0 2 1 2 1 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 1 1 2 1 1 1 1 1 2 1 1 1 2 0 1 1 2 0 1 1 2 0 1 1 2 0 1 0 2 0 0 47 -4 0 -4 -1 -5 0 -4 -1 -4 -1 -4 -1 -3 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -2 -3 -3 -3 -2 -3 -3 -3 -3 -2 -3 -3 -3 -2 -4 -2 -3 -2 -3 -2 -4 -2 -4 -1 -3 -2 -4 -1 -4 -1 -4 -1 -4 -1 -5 0 -4 0 -4 -1 -4 0 0zm81 -87l0 47 0 0 -2 0 -1 1 -2 0 -1 0 -2 1 -1 0 -2 1 -1 0 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 -1 2 -1 2 0 1 -1 2 0 2 0 2 -1 2 0 3 0 2 -47 0 1 -5 0 -4 0 -4 1 -4 1 -4 1 -4 1 -4 2 -4 1 -4 2 -4 2 -3 2 -4 2 -3 2 -3 3 -3 2 -4 3 -2 3 -3 3 -3 3 -2 3 -3 4 -2 3 -2 4 -1 4 -2 3 -1 4 -2 4 -1 4 0 5 -1 4 0 4 -1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M372 420c32,0 57,28 57,63 0,34 -25,62 -57,62 -32,0 -57,-28 -57,-62 0,-35 25,-63 57,-63z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 388,
    cy: 484,
    r: 52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M575 483l0 0 0 -5 0 -4 1 -4 0 -4 1 -4 1 -4 2 -4 1 -4 2 -4 1 -4 2 -3 2 -4 2 -3 3 -3 2 -3 3 -4 3 -2 2 -3 3 -3 4 -2 3 -3 3 -2 4 -2 3 -1 4 -2 4 -1 4 -2 4 -1 4 0 4 -1 4 0 4 -1 0 47 -1 0 -2 1 -1 0 -2 0 -2 1 -1 0 -2 1 -1 0 -1 1 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 0 2 -1 2 -1 1 0 2 -1 2 0 2 0 2 0 3 0 2 0 0 -47 0zm80 86l0 0 -4 0 -4 -1 -4 0 -4 -1 -4 -1 -4 -1 -4 -2 -4 -1 -3 -2 -4 -2 -3 -2 -3 -2 -4 -3 -3 -2 -2 -3 -3 -3 -3 -3 -2 -3 -3 -4 -2 -3 -2 -3 -2 -4 -1 -4 -2 -3 -1 -4 -2 -4 -1 -4 -1 -4 0 -5 -1 -4 0 -4 0 -4 47 0 0 2 0 2 0 2 0 2 1 2 0 2 1 2 1 2 0 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 2 1 1 1 1 1 2 1 1 1 2 1 1 0 1 1 2 0 1 1 2 0 2 1 1 0 2 0 1 0 0 0 0 47zm81 -86l0 0 0 4 0 4 -1 4 -1 5 0 4 -1 4 -2 4 -1 4 -2 3 -1 4 -2 4 -2 3 -2 3 -3 4 -2 3 -3 3 -3 3 -3 3 -3 2 -3 3 -3 2 -3 2 -4 2 -4 2 -3 1 -4 2 -4 1 -4 1 -4 1 -4 0 -4 1 -5 0 0 -47 2 0 2 0 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 -1 1 -1 2 -1 1 -1 1 -1 2 -2 1 -1 1 -2 1 -1 1 -2 1 -1 1 -2 1 -2 0 -1 1 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 0 -2 0 0 47 0zm-81 -87l0 0 5 1 4 0 4 1 4 0 4 1 4 2 4 1 3 2 4 1 4 2 3 2 3 3 3 2 3 3 3 3 3 2 3 4 2 3 3 3 2 3 2 4 2 3 1 4 2 4 1 4 2 4 1 4 0 4 1 4 1 4 0 4 0 5 -47 0 0 -2 0 -3 0 -2 -1 -2 0 -2 0 -2 -1 -1 -1 -2 0 -2 -1 -2 -1 -1 -1 -2 -1 -2 -1 -1 -1 -2 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 0 -1 -1 -2 0 -1 -1 -2 0 -1 0 -2 -1 -2 0 0 0 0 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M655 420c-31,0 -57,28 -57,63 0,34 26,62 57,62 32,0 58,-28 58,-62 0,-35 -26,-63 -58,-63z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 640,
    cy: 484,
    r: 52
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M452 567c-23,18 -11,33 -4,47 40,85 86,84 132,0 7,-14 18,-29 -5,-47 -28,-22 -95,-22 -123,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_552371192"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 624,
    cy: 483,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 403,
    cy: 483,
    r: 20
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni3);
export default __webpack_public_path__ + "static/media/ani3.31ff84284e2354ef995d0b2a043c87c0.svg";
export { ForwardRef as ReactComponent };